import { loadDatadog } from '../services/datadog'
import { loadIntercom } from '../services/intercom.js'
import { loadOnetrust } from '../services/onetrust'

const searchParams = new URLSearchParams(window.location.search)
const is2SVPushResponsePage = window.location.pathname.includes('/two_step_verification/push/response')

if (searchParams.get('no-cookies') !== 'true' && !is2SVPushResponsePage) {
  loadOnetrust()
}
loadIntercom()
loadDatadog()
